import componentSlider from "../../common/componentSlider.js";

export default () => {
  document.querySelectorAll(".js-promo-card-carousel").forEach((el) => {
    if (document.body.classList.contains("is-page-editor")) {
      return;
    }

    const cards = el.querySelectorAll(".js-promo-card-carousel__card");
    if (cards.length <= 2) {
      return;
    }

    const config = {
      slidesToShow: el.closest(".container__col--70") ? 2 : 3,
      slidesToScroll: el.closest(".container__col--70") ? 2 : 3,
      dots: false,
    };

    if (config.slidesToShow === 2) {
      config.responsive = [
        {
          breakpoint: 920,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ];
    } else {
      config.responsive = [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ];
    }

    componentSlider(el, config);
  });
};
